// src/components/CertificateCard.js
import React from "react";
import { Link } from "react-router-dom";
import { FaExternalLinkAlt, FaChevronRight, FaAward } from "react-icons/fa";
import "./CertificateCard.css";

const CertificateCard = ({
  id,
  imgsrc,
  completion_date,
  title,
  description,
  verify,
}) => {
  const preview =
    description.length > 120
      ? description.slice(0, 120).trimEnd() + "…"
      : description;

  return (
    <article className="cert-card card">
      {/* Image */}
      <div className="cert-card__img-wrap">
        <img
          src={
            imgsrc ||
            `https://picsum.photos/seed/${encodeURIComponent(title)}/600/400`
          }
          alt={title}
          loading="lazy"
        />
        <div className="cert-card__badge">
          <FaAward size={14} />
          Certified
        </div>
      </div>

      {/* Body */}
      <div className="cert-card__body">
        <span className="badge">{completion_date}</span>
        <h3 className="cert-card__title">{title}</h3>
        <p className="cert-card__desc">
          {preview}
        </p>

        <div className="cert-card__footer">
          <Link to={`/certifications/${id}`} className="btn btn-ghost cert-card__toggle">
            Read more <FaChevronRight size={11} />
          </Link>

          {verify && (
            <a
              href={verify}
              target="_blank"
              rel="noreferrer"
              className="btn btn-outline cert-card__verify"
            >
              Verify <FaExternalLinkAlt size={11} />
            </a>
          )}
        </div>
      </div>
    </article>
  );
};

export default CertificateCard;
